import React, { useEffect } from "react";
import { HOTSPOT_LABELS } from "../../lib/lumenDock";
import { IconSparkle, SURFACE_ICONS } from "../../lib/Icons/SessionIcons";

const TEAL = "#4DB8B5";
const TEAL_DARK = "#2F8C89";
const FONT = "'DM Sans', sans-serif";

export function leftOffText({ summary, roomName }) {
  if (summary && summary.trim()) return summary.trim();
  return roomName ? `Pick up your last chat in ${roomName}.` : "Pick up your last chat.";
}

export default function LumenLeftOffPopup({ surface, summary, nextStep, title, roomName, onPickUp, onNewSession, onClose }) {
  const hotspot = surface && HOTSPOT_LABELS[surface] ? surface : null;
  const Icon = hotspot ? SURFACE_ICONS[hotspot] || IconSparkle : IconSparkle;
  const label = hotspot ? HOTSPOT_LABELS[hotspot] : "Lumen chat";

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      data-lumen-left-off
      role="dialog"
      aria-label="Where you left off"
      style={{
        position: "fixed", left: "50%", top: "46%", transform: "translate(-50%, -50%)", zIndex: 70,
        width: "min(560px, calc(100vw - 32px))", boxSizing: "border-box", padding: "26px 28px 24px",
        borderRadius: 18, background: "rgba(250,248,244,0.97)", border: "1px solid rgba(0,0,0,0.08)",
        boxShadow: "0 18px 50px rgba(0,0,0,0.22)", fontFamily: FONT,
      }}
    >
      <button
        type="button"
        onClick={onClose}
        aria-label="Close"
        style={{ position: "absolute", top: 12, right: 14, border: "none", background: "none", color: "#94A3B8", fontSize: 20, lineHeight: 1, cursor: "pointer", padding: 4 }}
      >
        ×
      </button>
      <div style={{ fontSize: 14, color: "#64748B", marginBottom: 10 }}>Where you left off</div>
      <div data-left-off-hotspot={hotspot || "none"} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: title ? 4 : 12, color: TEAL_DARK }}>
        <Icon size={22} />
        <span style={{ fontSize: 20, fontWeight: 700, color: "#1E293B" }}>{label}</span>
      </div>
      {title && (
        <div data-left-off-chat style={{ fontSize: 13, color: "#64748B", marginBottom: 12, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          Chat: {title}
        </div>
      )}
      <p style={{ margin: 0, fontSize: 16, lineHeight: 1.6, color: "#1E293B" }}>
        {leftOffText({ summary, roomName })}
      </p>
      {nextStep && nextStep.trim() && (
        <p style={{ margin: "8px 0 0", fontSize: 14, lineHeight: 1.5, color: "#64748B" }}>Next: {nextStep.trim()}</p>
      )}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 22 }}>
        <button
          type="button"
          onClick={onPickUp}
          style={{ padding: "12px 20px", borderRadius: 12, border: "none", background: TEAL, color: "white", fontSize: 15, fontWeight: 600, fontFamily: FONT, cursor: "pointer" }}
        >
          Pick up where I left off
        </button>
        <button
          type="button"
          onClick={onNewSession}
          style={{ padding: "12px 20px", borderRadius: 12, border: `1.5px solid rgba(0,0,0,0.14)`, background: "white", color: "#1E293B", fontSize: 15, fontWeight: 600, fontFamily: FONT, cursor: "pointer" }}
        >
          Start a new session
        </button>
      </div>
    </div>
  );
}
